import React from 'react';
import { XIcon } from 'lucide-react';
import { pains } from '../data/salesCopy';
export function ProblemSection() {
  return <section className="w-full border-y border-line bg-night-deep" data-id="element-191" data-mp="2ltmgzr0xdnkj">
      <div className="mx-auto max-w-5xl px-4 py-10 text-center sm:px-5 sm:py-16 lg:py-20" data-id="element-192" data-mp="30hpsth1nfth9">
        <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-gold sm:text-xs sm:tracking-[0.28em]" data-id="element-193" data-mp="2vqr4pvaf5r3g">
          The reality of teaching guitar
        </p>
        <h2 className="mx-auto mt-4 max-w-3xl font-display text-[1.75rem] uppercase leading-[1] tracking-tight text-cream sm:text-5xl" data-id="element-194" data-mp="39jqm62trhvdn">
          Does this sound <span className="text-gold" data-id="element-195" data-mp="3jf0pctvwc8t0">like you?</span>
        </h2>
        <p className="mx-auto mt-4 max-w-2xl font-serif text-base italic leading-snug text-cream-muted sm:text-xl" data-id="element-196" data-mp="3eh8nb71jf6b3">
          How much longer are you willing to improvise every lesson?
        </p>

        <ul className="mt-9 grid grid-cols-1 gap-3 text-left sm:mt-12 sm:grid-cols-2 sm:gap-4" data-id="element-197" data-mp="1k37mwhqcab8w">
          {pains.map(pain => <li key={pain} className="flex items-start gap-3 rounded-xl border border-line bg-panel p-4 sm:p-5" data-id="element-198" data-mp="je6c4p9sa246">
              <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-199" data-mp="sdtf3fi5vfzc" />
              <span className="text-[15px] leading-relaxed text-cream-muted" data-id="element-200" data-mp="sbyszxv5lhto">{pain}</span>
            </li>)}
        </ul>

        <p className="mx-auto mt-9 max-w-2xl text-[15px] leading-relaxed text-cream sm:text-base" data-id="element-201" data-mp="1244jf35rbr6r">
          You should be spending your time teaching and changing lives — not stuck behind a screen
          formatting worksheets.
        </p>
      </div>
    </section>;
}